/* Bounded width fitting for the existing desktop nav. No clones, polling, or body observer. */
(function () {
  'use strict';
  if (window.__mipSingleLineMenu) return;
  window.__mipSingleLineMenu = true;
  var desktop = matchMedia('(min-width: 1025px)');
  var records = new Map(), frame = 0;
  function set(nav, key, value) {
    value = Math.round(value * 100) / 100 + 'px';
    if (nav.style.getPropertyValue(key) !== value) nav.style.setProperty(key, value);
  }
  function reset(nav) {
    ['--mip-nav-font', '--mip-nav-letter', '--mip-nav-padding'].forEach(function (key) { nav.style.removeProperty(key); });
    nav.classList.remove('mip-nav-overflow');
  }
  function fit(nav) {
    if (!nav.isConnected) { remove(nav); return; }
    if (!desktop.matches) { reset(nav); return; }
    var list = nav.querySelector(':scope > .list-menu--inline');
    if (!list || nav.clientWidth < 20 || !nav.getClientRects().length) return;
    var items = Array.from(list.children).filter(function (item) { return item.matches('.menu-lv-1') && getComputedStyle(item).display !== 'none'; });
    if (!items.length) return;
    var style = getComputedStyle(nav);
    var maxFont = parseFloat(style.getPropertyValue('--font-menu-lv1-size')) || 14;
    var minFont = Math.min(11, maxFont);
    var maxPadding = Math.min(32, Math.max(2, parseFloat(style.getPropertyValue('--grid_gap_menu_item')) || 0));
    var maxLetter = parseFloat(style.getPropertyValue('--menu-lv1-letter-spacing')) || 0;
    var available = nav.clientWidth - 2;
    // Start from the server-rendered menu settings. This avoids a visible
    // small-text-to-normal-text jump during the first paint.
    reset(nav);
    function used() { return items.reduce(function (sum, item) { return sum + item.getBoundingClientRect().width; }, 0); }
    var width = used();
    if (width <= available) return;

    // Only write temporary fit values when the configured menu truly needs
    // them for the current desktop width.
    set(nav, '--mip-nav-font', maxFont); set(nav, '--mip-nav-padding', maxPadding); set(nav, '--mip-nav-letter', maxLetter);
    width = used();
    if (width > available) {
      // Reduce only empty spacing first; keep the configured font wherever possible.
      var padding = Math.max(2, maxPadding - (width - available) / (2 * items.length) - .1);
      set(nav, '--mip-nav-padding', padding); width = used();
    }
    if (width > available && maxLetter > 0) { set(nav, '--mip-nav-letter', 0); width = used(); }
    if (width > available) {
      set(nav, '--mip-nav-font', minFont);
      if (used() <= available) {
        // Seven bounded probes; never a while-until-fit loop.
        var low = minFont, high = maxFont;
        for (var i = 0; i < 7; i += 1) {
          var mid = (low + high) / 2; set(nav, '--mip-nav-font', mid);
          if (used() <= available) low = mid; else high = mid;
        }
        set(nav, '--mip-nav-font', low);
      }
    }
    nav.classList.toggle('mip-nav-overflow', used() > available + 1);
  }
  function schedule() {
    if (frame) return;
    frame = requestAnimationFrame(function () { frame = 0; records.forEach(function (_, nav) { fit(nav); }); });
  }
  function remove(nav) {
    var record = records.get(nav); if (!record) return;
    if (record.observer) record.observer.disconnect(); reset(nav); records.delete(nav);
  }
  function init(scope) {
    (scope || document).querySelectorAll('.header-nav-plain [data-mip-nav-fit]').forEach(function (nav) {
      if (records.has(nav)) return;
      var record = { observer: null, lastWidth: -1 }; records.set(nav, record);
      if ('ResizeObserver' in window) {
        record.observer = new ResizeObserver(function (entries) {
          var width = entries[0].contentRect.width;
          // Ignore height-only changes from this controller; writes run in a later frame.
          if (Math.abs(width - record.lastWidth) > .5) { record.lastWidth = width; schedule(); }
        });
        record.observer.observe(nav);
      }
    });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }, { once: true }); else init();
  window.addEventListener('resize', schedule, { passive: true });
  desktop.addEventListener('change', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('pagehide', function () { cancelAnimationFrame(frame); frame = 0; });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    records.forEach(function (_, nav) { if (event.target.contains(nav)) remove(nav); });
  });
})();
